// Import Material UI
import {Button, CircularProgress, Dialog, DialogContent, DialogTitle, Tooltip} from "@material-ui/core"
import {Close} from "@material-ui/icons"

// Import Packages
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

// Import Helper
import {
    convertToDateFormat
} from "../../../../helpers/helper";


// Import Icons
import emptyPageIcon from '../../../../assets/icons/configurationIcons/empty-page.svg';
import InfoIcon from '../../../../assets/icons/info-icon.svg';

// Import Recoil
import {useRecoilValue} from "recoil";
import {personalizationState} from "../../../../recoil-store/recoil-state";

// Import CSS
import "./OperationLogs.css";
import OperationService from "../../../../services/OperationService/OperationService";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";

export const ProgressOperationLogs = ({
                                          data,
                                          setOpenProgressActivityLog,
                                          setSelectedOperation,
                                          handleShowAllProgressOperationLogs
                                      }) => {
    const {t} = useTranslation();
    const [operationData, setOperationData] = useState({})
    const [isNewLogs, setIsNewLogs] = useState(false)
    const [logsCount, setLogsCount] = useState(0);
    const [loading, setLoading] = useState(false)
    const [type, setType] = useState("input");
    const [selectedLog, setSelectedLog] = useState({});
    const personalization = useRecoilValue(personalizationState);
    const label = "MESSAGES.MONITORING."

    const handleClose = () => {
        setSelectedOperation({})
        setOpenProgressActivityLog(false)
    }

    useEffect(() => {
        fetchData()
    }, [data]);

    useEffect(() => {
        setType("input")
    }, [selectedLog]);

    const fetchData = (page, itemsPerPage) => {
        // Current date and time
        const startDate = new Date();
        // Date and time of 24 hours back
        const endDate = new Date();
        endDate.setDate(endDate.getDate() - 1); // Start from yesterday
        endDate.setHours(startDate.getHours()); // Make the hour as same

        setLoading(true);
        OperationService.getOperationTrigger(`?operation_id=${data.operation_id}`)
            .then((response) => {
                if (response && response.data && response.code === 200) {
                    setOperationData(response.data)
                    setIsNewLogs(true)
                } else {
                    setIsNewLogs(false)
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false)
                //err
            });
    }

    return (
        <Dialog
            id="operation-log-dialog"
            data-test="autom-add-new"
            className="autom-group"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    minWidth: 696.89,
                    minHeight: 411.57,
                    maxWidth: "none",
                    width: selectedLog.level ? "68.5%" : "fit-content",
                    height: selectedLog.level ? "90%" : "411.57px",
                    borderRadius: " 4px",
                    backgroundColor: "transparent",
                    boxShadow: selectedLog.level ? "none" : "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
                    flexDirection: "row",
                    gap: "20px",
                },
            }}
        >
            <div className="operation-container" style={{maxWidth: selectedLog?.level ? "none" : "411.57px"}}>
                <div>
                    <DialogTitle id="alert-dialog-title">
                        <Tooltip placement="top" title={data.autom_name}>
                            <div id="about-title" className="add-group-header">
                                <div className="operation-tag-title-container">
                                    <div
                                        className={`autom-name-title-status operation-status-dot-${data.operation_status ? data.operation_status.toLowerCase()
                                            : data.scheduled_at ? "schedule" : ""}`}></div>
                                    <h4 className="autom-name-title">{data.autom_name}</h4>
                                </div>
                            </div>
                        </Tooltip>
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            <h5 className='logs-info-text'>{t(label + `TRIGGER-TYPE`)}</h5>
                            <p className="bold-logs-info">{data.trigger_type ? data.trigger_type : "Manual Trigger"}</p>
                        </div>
                        <div>
                            <h5 className='logs-info-text'>{t(label + `RUN-BY`)}</h5>
                            <p className="bold-logs-info">{data.run_by ? data.run_by : "-"}</p>
                        </div>
                    </DialogContent>
                </div>
                <div className="logs-seperator"></div>
                <div className="recent-logs-container">
                    <div className="recent-logs-header-container">
                        <div>
                            <h4 className="recent-logs-title">{t(label + `LOGS-SUMMARY`)}</h4>
                            <small
                                className="conf-field-desc"><em>{t(label + `LOGS-SUMMARY-DESCRIPTION`)}</em></small>
                        </div>
                        <div className="logs-button-container">
                            <Close className="autom-group-close-button logs-close-icon" onClick={handleClose}
                                   style={{fontSize: "1rem"}}/>
                            <Button onClick={() => handleShowAllProgressOperationLogs(data)}
                                    className="view-all-logs-button">{t(label + `VIEW-ALL-LOGS`)} {!isNewLogs ? `(${logsCount})` : ""}</Button>
                        </div>
                    </div>
                    <DialogContent className="log-detail-container">
                        {loading ? <div className='db-create-loading-page'><CircularProgress/></div>
                            : isNewLogs
                                ?
                                <div
                                    className={`log-row-container log-summary-container bigger-row info`}>
                                    <div className="log-row log-summary-row">
                                        <img alt="action-completed-icon" className='circle' src={InfoIcon}/>
                                        <p className='log-action-name log-summary-info'>{t(label + "IN-OPERATION")}</p>
                                    </div>
                                    <div className='child-log-row first-child-log success-child-log-row'>
                                        <div className="all-logs-quick-info-start">
                                            <div className='all-logs-quick-info-timestamp-header'>
                                                <PlayCircleFilledWhiteIcon color='red' className='log-action-image'/>
                                                <span className="info-body-row-value">{t(label + `STARTED-AT`)}</span>
                                            </div>
                                            <span
                                                className="time-of-log">{convertToDateFormat(operationData.created_at, personalization.date_format)}</span>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='empty-page-info-container'>
                                    <img alt="empty-page" src={emptyPageIcon}/>
                                    <p className='info-text'>{t(label + 'EMPTY-LOGS')}</p>
                                </div>
                        }
                    </DialogContent>
                </div>
            </div>
        </Dialog>
    )
}
